<template>
  <vx-card class="mt-base" :title="activityTitle">
    <h4 class="mb-5"><strong>Basic 3 Strand Braid</strong></h4>
    <p class="mb-5">For this activity, you’ll need either:</p>

    <ul class="default-list">
      <li>A wig</li>
      <li>A styrofoam head (a ball or similar may serve this purpose)</li>
    </ul>
    <p>Or</p>
    <ul class="default-list">
      <li>A volunteer</li>
    </ul>
    <p class="mb-5">
      One common task assigned to apprentice or trainee hairdressers is plaiting or braiding a
      client's hair.
    </p>
    <p class="mb-5">
      Start by placing the wig onto a styrofoam head or similar, preferably use a long-haired
      volunteer to work with for this activity.
    </p>
    <p class="mb-5">
      Now, watch the following video to learn how to do the basic 3-strand braid. Then practise on
      your ‘volunteer,’ in whatever form they come in!
    </p>
    <responsive-youtube-wrapper :video="videos[1]" :image="videoTrigger1" />

    <p class="mb-5">
      Practice this simple braid until you’ve mastered it.<br />
      Once you can do this easily, it’s time to learn a few more variations.
    </p>
    <h4 class="mb-5"><strong>Six Basic Braids</strong></h4>
    <p class="mb-5">Lots more to get your teeth into hair...I mean here.</p>
    <p class="mb-5">
      <strong
        >NOTE: When you do these remember to photograph them all so you can upload your best work
        below.</strong
      >
    </p>
    <p class="mb-5">
      Take your time and work through each one. Give yourself time to practice each before moving
      onto the next one.
    </p>
    <responsive-youtube-wrapper :video="videos[2]" :image="videoTrigger2" />

    <p class="mb-5">
      To finish up this Activity, upload up to 3 photos of your best plaiting/braiding work:
    </p>
    <div v-for="index in 3" :key="index">
      <fileupload-button-immediate
        v-model="uploaded_files['uploaded_file_' + index]"
        :is-editable="isEditable"
        filetype="photo"
        :index="index"
      />
    </div>
    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';

export default {
  data() {
    return {
      videoTrigger1: require('@/assets/images/experiences/hairdressing/3_strand_braid_splash.jpg'),
      videoTrigger2: require('@/assets/images/experiences/hairdressing/6_strand_braid_splash.jpg'),
      videos: {
        1: 'https://www.youtube.com/embed/QMW0bwYzaAM',
        2: 'https://www.youtube.com/embed/TKOsS4FDyi4',
      },
      uploaded_files: {
        uploaded_file_1: '',
        uploaded_file_2: '',
        uploaded_file_3: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>

<style scoped>
.wrong {
  background: rgba(202, 20, 20, 0.24);
  border-bottom: 1px solid #f8f8f8;
  padding-top: 2px;
}
.correct {
  background: rgba(75, 202, 20, 0.24);
  border-bottom: 1px solid #f8f8f8;
}

.workplace_module {
  overflow: hidden;
  padding: 10px 0;
  border-bottom: 1px solid #dedede;
}
.workplace_module:last-child {
  border-bottom: none;
}
p.module_name {
  float: left;
  font-size: 16px;
  font-weight: 600;
  padding-top: 10px;
}
.prework_icon {
  float: right;
  width: 10%;
  text-align: center;
}
select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
</style>
